import React from 'react';
import { View, Image, TouchableOpacity } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import {
  getThemeImages,
  withTheme,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './DashboardErrorCard.styles';

const DashboardErrorCard = ({
  errorText,
  errorHandler,
  errorImage,
  tryAgainImage,
  isVerticalLayout,
  isHorizontalLayout,
  accessibilityID,
  theme,
  errorDetailsTextStyle,
}) => {
  const images = getThemeImages(theme.name);
  return (
    <View
      style={styles.outerViewStyle(isVerticalLayout)}
      testID={accessibilityID ?? FrameworkTestKeys.dashboardErrorCardOuterView}
    >
      <View
        style={styles.errorDetailsViewStyle(isVerticalLayout)}
        testID={FrameworkTestKeys.dashboardErrorCardView}
      >
        <Image
          source={errorImage || images.ic_warning_mid}
          style={styles.errorDetailsImageStyle(isVerticalLayout)}
          testID={FrameworkTestKeys.ErrorIcon}
        />
        <VFText
          i18nKey={errorText}
          style={[styles.errorDetailsTextStyle(theme), errorDetailsTextStyle]}
          testKey={FrameworkTestKeys.ErrorText}
        />
      </View>
      <View
        style={styles.errorActionViewStyle}
        testID={FrameworkTestKeys.dashboardErrorCardActionView}
      >
        <TouchableOpacity
          style={styles.errorActionClickStyle(isHorizontalLayout)}
          onPress={errorHandler}
          accessible={false}
          testID={FrameworkTestKeys.dashboardErrorCardActionViewTO}
        >
          <VFText
            i18nKey="dashboard_loading_error_try_again_button"
            style={styles.errorActionTextStyle(theme)}
            testKey={FrameworkTestKeys.ErrorTryAgainText}
          />
          <Image
            source={tryAgainImage || images.ic_RefreshRed}
            style={styles.errorActionImageStyle(isVerticalLayout)}
            testID={FrameworkTestKeys.ErrorArrow}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

DashboardErrorCard.propTypes = {
  errorText: PropTypes.string,
  errorHandler: PropTypes.func,
  theme: PropTypes.object,
  isVerticalLayout: PropTypes.bool,
  isHorizontalLayout: PropTypes.bool,
  accessibilityID: PropTypes.string,
  errorImage: PropTypes.object,
  tryAgainImage: PropTypes.object,
  errorDetailsTextStyle: TextPropTypes.style,
};
DashboardErrorCard.defaultProps = {
  theme: LightThemeColors,
  isVerticalLayout: true,
};
export default withTheme(DashboardErrorCard);
